var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGolemRoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_copy",
    "data-name": "Layer 1 copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e4b287;\n      }\n\n      .cls-2 {\n        fill: #36281c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    className: "cls-1",
    d: "M39.5055,74.51c-4.4768-.6913-14.9223-2.8948-14.9223-8.3766A56.958,56.958,0,0,1,26.1151,57.14a1.43,1.43,0,0,1,.06-.2735c.035-.1691.1093-.4973.2089-.92a1.3476,1.3476,0,0,1-.776.4675,1.3257,1.3257,0,0,1-.2787.03A1.3633,1.3633,0,0,1,24.27,55.947,16.0767,16.0767,0,0,1,20.36,45.7c0-8.3565,7.1181-15.773,18.1653-18.9912a15.0817,15.0817,0,0,1,11.61-6.9936A15.1311,15.1311,0,0,1,61.8,26.7237C72.8167,29.9571,79.9048,37.3633,79.9048,45.7a16.0579,16.0579,0,0,1-3.9,10.2318,1.3684,1.3684,0,0,1-1.06.4973,1.2621,1.2621,0,0,1-.2787-.03,1.3427,1.3427,0,0,1-.776-.4675c.1394.6069.229.9949.2438,1.07a58.6332,58.6332,0,0,1,1.552,9.1373c0,5.4714-10.396,7.6752-14.8677,8.3714a1.8664,1.8664,0,0,1-.2089,0,1.3726,1.3726,0,0,1-1.1093-.562c-.4278-.5869-.8656-1.2086-1.3131-1.84C55.805,68.73,52.84,64.5273,50.13,64.5273s-5.6208,4.1881-7.9885,7.5556c-.4576.6467-.9005,1.2784-1.338,1.8753a1.3726,1.3726,0,0,1-1.1093.562A1.2143,1.2143,0,0,1,39.5055,74.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    className: "cls-2",
    d: "M39.7144,77.1812a3.7959,3.7959,0,0,1-.6117-.0446h0C31.2635,75.928,21.9121,73.0329,21.9121,66.109a49.1247,49.1247,0,0,1,1.1789-7.6949,4.1263,4.1263,0,0,1-.87-.7809,18.7478,18.7478,0,0,1-4.5263-11.938c0-9.3264,7.5307-17.6234,19.27-21.3139a17.1265,17.1265,0,0,1,13.1864-7.3519,17.2,17.2,0,0,1,13.245,7.3616C75.0952,28.0967,82.6013,36.3836,82.6013,45.69A18.6894,18.6894,0,0,1,78.09,57.6281a3.9489,3.9489,0,0,1-.88.8009,49.0362,49.0362,0,0,1,1.1788,7.7049c0,6.9141-9.3265,9.8089-17.1407,11.0178a3.8431,3.8431,0,0,1-.6218.05A4.059,4.059,0,0,1,57.3527,75.54c-.4177-.572-.8455-1.1789-1.2833-1.7958l-.0546-.08c-1.2387-1.7508-4.5166-6.3967-5.8694-6.4662-1.348.0944-4.5713,4.6857-5.79,6.4116l-.2289.3233c-.388.5523-.766,1.0893-1.1391,1.6018A4.0687,4.0687,0,0,1,39.7144,77.1812ZM28.7765,57.5583l-.035.1791a56.3309,56.3309,0,0,0-1.4672,8.3914c0,2.1091,4.9392,4.427,11.8533,5.5959l.6169-.87.2289-.3185c2.86-4.0688,6.1083-8.6847,10.1771-8.6847s7.3668,4.6259,10.2418,8.7147l.0547.0747.7711,1.0793c6.8993-1.1789,11.8087-3.4819,11.8087-5.5959a59.02,59.02,0,0,0-1.4922-8.54V57.479c-.0349-.1542-.1093-.4973-.2189-.95L68.7042,45.4269l6.2225,7.5009a12.9637,12.9637,0,0,0,2.328-7.2423c0-7.0832-6.3519-13.5246-16.1759-16.4145l-.8358-.2438-.5322-.6864c-6.1032-7.8841-12.8831-7.9585-19.0309,0l-.5323.6913-.8406.2437c-9.8587,2.87-16.2306,9.3165-16.2306,16.4146a12.9969,12.9969,0,0,0,2.3329,7.2571l6.1329-7.4314Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    className: "cls-2",
    cx: 52.8011,
    cy: 27.5644,
    rx: 1.3132,
    ry: 0.7461
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    className: "cls-2",
    cx: 47.4888,
    cy: 27.5644,
    rx: 1.3132,
    ry: 0.7461
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolemRoundIcon);
export default __webpack_public_path__ + "static/media/golem-round-icon.ba52b4713940e03545ccae9e115554f8.svg";
export { ForwardRef as ReactComponent };